import { type FC } from "react";

import { useSCMAuthentication } from "@/hooks/use-scm-authentication.ts";
import { SCMAuthentication, type SCMAuthenticationModalProps } from "@/routes/environments/create/SCMAuthentication";

export const Authentication: FC<SCMAuthenticationModalProps> = (p) => {
    const props = useSCMAuthentication({
        repoURL: p.repoURL,
        authenticationUrl: p.authenticationUrl,
        runnerId: p.runnerId,
    });
    return <SCMAuthentication {...{ ...p, ...props }} />;
};
